import { c as _c } from "react/compiler-runtime";
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const CSSScrollSnapCarousel = t0 => {
  const $ = _c(14);
  const {
    slides: t1,
    className: t2,
    onSlideChange
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const slides = t3;
  const className = t2 === undefined ? "" : t2;
  const scrollContainerRef = useRef(null);
  let t4;
  if ($[2] !== onSlideChange) {
    t4 = () => {
      if (!scrollContainerRef.current || !onSlideChange) {
        return;
      }
      const container = scrollContainerRef.current;
      const {
        scrollLeft
      } = container;
      const slideWidth = container.clientWidth;
      const currentSlide = Math.round(scrollLeft / slideWidth);
      onSlideChange(currentSlide);
    };
    $[2] = onSlideChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleScroll = t4;
  let t5;
  if ($[4] !== className) {
    t5 = classNames("CSSScrollSnapCarousel", className);
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== slides) {
    t6 = slides.map(_temp);
    $[6] = slides;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleScroll || $[9] !== t6) {
    t7 = <div ref={scrollContainerRef} className="flex overflow-x-auto overflow-y-hidden w-full scroll-smooth snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" onScroll={handleScroll}>{t6}</div>;
    $[8] = handleScroll;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
CSSScrollSnapCarousel.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    slide: PropTypes.node.isRequired
  })).isRequired,
  className: PropTypes.string,
  onSlideChange: PropTypes.func
};
export default CSSScrollSnapCarousel;
function _temp(t0) {
  const {
    key,
    slide
  } = t0;
  return <div key={key} className="flex-shrink-0 w-full h-full snap-start">{slide}</div>;
}